export const selectUsersInfo = (state) => state.systemAdmin.usersInfo;
export const selectIsUsernameAndPassword = (state) =>
  state.systemAdmin.isUsernamePassword;
